import { playVo } from './audio';

export default class NavItemVo {
  constructor() {
    this.elements = document.getElementsByClassName('nav-item__target') || false;

    this.triggerVo = this.triggerVo.bind(this);

    if (this.elements) {
      for (var i = 0; i < this.elements.length; i++) {
        this.addEvents(this.elements[i]);
      }
    }
  }

  addEvents(el) {
    el.addEventListener('mouseover', (e) => {
      this.triggerVo(`vo_nav_${e.target.offsetParent.dataset.label.toLowerCase()}`);
    });
  }

  triggerVo(id) {
    playVo(id);
  }
}
